export const loadState = () => {
    try {
        const serializedData = sessionStorage.getItem('state')
        if (serializedData === null) {
            const initialState = {
                productsTable: '',
                categoriesAll: [],
                otherCategoriesAll: [],
                allProducts: [],
                productsToShow: [],
                productsChild: [],
                productsCategory: [],
                allColors: [],
                productosListRouteOrigin: null,
                selectedCategory: null,
                selectedCategoryName: null,
                selectedCollection: null,
                selectedForma: null,
                selectedHole: null,
                selectedCharacteristic: [],
                selectedColor: {},
                minMaxDiameter: null,
                filters: [],
                headerData: {
                    title: 'CATEGORÍA',
                    subtitle: '',
                    img: ''
                },
                budget: [],
                formatSelected: null,
                quantitySelected: null,
                totalSelected: null,
                userActive: {},
                state: {},
                popup: {
                    active: null,
                    message: '',
                    type: ''
                },
                spinner: false,
                search: false,
                zones: { region: [], country: [] },
                paginationState: null
            }
            return initialState // Si no existe el state en el local storage devolvemos undefined para que cargue el state inicial que hayamos definido
        }
        return JSON.parse(serializedData) // Si encontramos con exito nuestro storage lo devolvemos.
    } catch (error) {
        return undefined // Si ocurre algun error, devuelvo undefined para cargar el state inicial.
    }
}

export const saveState = (state) => {
    try {
        let serializedData = JSON.stringify(state)
        sessionStorage.setItem('state', serializedData)
    } catch (error) {
        console.log('error', error)
        // Acá podemos capturar o crear cualquier log que deseemos en caso de que falle el salvado en el storage.    
    }
}